import { LOGOUT } from "constants/auth.const"

export function logout() {
    return {
        type: LOGOUT
    }
}

